import { createContext, PropsWithChildren, useContext } from 'react';

import { TargetEntityOptions } from './types';

const defaultTargetEntityOptions: TargetEntityOptions = {
  convertableTarget: null,
};
const ErpDialogTargetOptionsContext = createContext<TargetEntityOptions>(
  defaultTargetEntityOptions
);

export const ErpDialogTargetOptionsProvider = (
  props: PropsWithChildren<{ value: TargetEntityOptions | undefined }>
) => {
  const { value, children } = props;
  return (
    <ErpDialogTargetOptionsContext.Provider
      value={value || defaultTargetEntityOptions}
    >
      {children}
    </ErpDialogTargetOptionsContext.Provider>
  );
};

export const useErpDialogTargetOptions = (): TargetEntityOptions => {
  const context = useContext(ErpDialogTargetOptionsContext);
  if (context === undefined) {
    throw new Error(
      'useErpDialogTargetOptions must be used within ErpDialogTargetOptionsProvider'
    );
  }
  return context;
};

export default ErpDialogTargetOptionsProvider;
